export default __webpack_public_path__ + "content/media/llinksate.72a051c8.png";